import { render, staticRenderFns } from "./ViqReportTypeSelector.vue?vue&type=template&id=577fd04f&scoped=true"
import script from "./ViqReportTypeSelector.vue?vue&type=script&lang=js"
export * from "./ViqReportTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./ViqReportTypeSelector.vue?vue&type=style&index=0&id=577fd04f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577fd04f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577fd04f')) {
      api.createRecord('577fd04f', component.options)
    } else {
      api.reload('577fd04f', component.options)
    }
    module.hot.accept("./ViqReportTypeSelector.vue?vue&type=template&id=577fd04f&scoped=true", function () {
      api.rerender('577fd04f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqReportTypeSelector.vue"
export default component.exports